import React from 'react';

import { Empty } from 'antd';

import styles from './TableEmpty.module.css';

type TableEmptyProps = {
  searchQuery?: string;
  isVisibleColumns?: boolean;
  description?: string;
  height?: string | number;
};

const getDescription = (description?: string, isVisibleColumns?: boolean, searchQuery?: string) => {
  const isSearchEmpty = !!searchQuery;

  if (isVisibleColumns) return '등록된 컬럼이 없습니다.';
  if (isSearchEmpty) return `"${searchQuery}"에 대한 검색 결과가 없습니다.`;
  return description;
};

export const TableEmpty: React.FC<TableEmptyProps> = ({
  searchQuery,
  isVisibleColumns = false,
  description = '데이터가 없습니다.',
  height = '195px',
}) => {
  const displayDescription = getDescription(description, isVisibleColumns, searchQuery);

  return (
    <div className={styles.tableEmpty} style={{ minHeight: height }}>
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<span className={styles.description}>{displayDescription}</span>}
      />
    </div>
  );
};
